import { LOCALES } from '../constant'

export function getLocale() {
  if (localStorage.getItem('locale') === null) {
    localStorage.setItem('locale', 'tw')
  }
  return localStorage.getItem('locale')
}

export function getLocaleLang() {
  console.log(LOCALES)
  return LOCALES[getLocale()].lang
}

export function getLocaleDefaultLoc() {
  return {
    'lat': LOCALES[getLocale()].defaultLat,
    'lng': LOCALES[getLocale()].defaultLng
  }
}

export function getLocaleAdjustLng() {
  return LOCALES[getLocale()].adjustLng
}

export function getLocaleApi() {
  return LOCALES[getLocale()].api
}

export function setLocale(lang) {
  console.log('change to', lang)
  if (!(lang in LOCALES)) {
    console.warn(lang, 'is not in locales!')
  }
  localStorage.setItem('locale', lang)
}

console.log(getLocale())
